/**
 * The browser-side fusion engine lives in `web/src/engine/` (built in parallel). The glob
 * keeps this branch building while that file doesn't exist yet: when it's absent the map
 * is empty and the app runs on labelled demo data.
 */
const loaders = import.meta.glob('../../engine/client.ts')
const KEY = '../../engine/client.ts'

export const ENGINE_AVAILABLE = KEY in loaders

export async function loadEngineModule(): Promise<unknown> {
  const load = loaders[KEY]
  if (!load) throw new Error('Engine not bundled')
  return load()
}
